module.exports = __webpack_public_path__ + "static/media/banana-bnb.85fb4ccc.svg";